import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores/store';
import styles from './EnergyProfileBanner.module.scss';
import completeEnergyProfileGif from '../../../../assets/gifs/complete-energy-profile.gif';
import { StopwatchIcon } from '../../../../assets/icons';
import { ApplicationRoutes } from '../../../../routes';

const LightsBackground = () => (
  <svg
    className={styles.bgSvg}
    width="267"
    height="237"
    viewBox="0 0 267 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 237V211.117L107.032 151.591L0 237ZM0 195.637V136.585L50.728 109.202L0 195.637Z"
      fill="white"
      fillOpacity="0.05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121.883 0H184.492L136.196 67.0258L256.714 0H266.252L152.489 86.9754L38.7269 173.951L107.747 42.9101L0 115.612V85.1932L121.883 0Z"
      fill="white"
      fillOpacity="0.05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.0113 0L11.4766 39.4005L32.2288 0H63.0113Z"
      fill="white"
      fillOpacity="0.05"
    />
  </svg>
);

const InfoCircleIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="7.5" r="6.5" stroke="white" strokeOpacity="0.5" />
    <text x="7.5" y="11" textAnchor="middle" fill="white" fillOpacity="0.6" fontSize="9" fontWeight="bold">i</text>
  </svg>
);

export const EnergyProfileBanner: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const energyProfile = useSelector((state: RootState) => state.customerEnergyProfile);
  const hasProfile = !!energyProfile?.meterNumber;

  const handleAction = () => {
    if (hasProfile) {
      navigate(`/${ApplicationRoutes.CUSTOMER_ENERGY_MANAGEMENT}`);
    } else {
        navigate(`/${ApplicationRoutes.SETTINGS}/${ApplicationRoutes.ENERGY_PROFILE_WELCOME}`);
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.iconCircle}>
          <img src={completeEnergyProfileGif} style={{ width: '100px', height: '100px' }} alt="" />
        </div>
        <div className={styles.textContent}>

          <div className={styles.trackLabel}>
            <span>{t('energyManagement.energyProfile.trackUsage')}</span>
            <StopwatchIcon />
          </div>
          <h2 className={styles.title}>
            {hasProfile ? t('home.web.yourEnergyProfileIsActive') : t('energyManagement.energyProfile.completeYourEnergyProfile')}
          </h2>
          <p className={styles.subtitle}>
            {hasProfile
              ? t('home.web.meterWithNumber', { meterNumber: energyProfile.meterNumber })
              : t('energyManagement.energyProfile.completeYourEnergyProfileText')}
          </p>
          <button className={styles.actionBtn} onClick={handleAction}>
            {hasProfile ? t('home.web.viewUsage') : t('common.labels.startNow')} <span className={styles.arrow}>→</span>
          </button>
        </div>
      </div>
    </div>
  );
};
